import React from "react";

const Stacked = () => (
  <div className="background">
    <div></div>
    <div></div>
    <div></div>
    <div></div>
  </div>
);

export default Stacked;
